import React, { useContext } from 'react';
import styled from 'styled-components';
import Radio from 'semantic-ui-react/dist/commonjs/addons/Radio';
import FlexWrapper from '../common/flex';
import useGUID from '../../utils/useGUID';
import L, { useTranslation } from '../common/localized';
import I18nContext from '../../contexts/i18n';

const SubscribeGenderInterestRadioButtons = ({ value, onChange, invertedColors, removeTitle, forPopup }) => {
  const guid = useGUID();
  const name = 'sub-interest-' + guid;
  const { t } = useTranslation();
  const i18nSettings = useContext(I18nContext);
  const isRtl = i18nSettings.isLocaleRTL();
  return (
    <RadioButtonsContainer forPopup={forPopup}>
      {!removeTitle && <Title dir={isRtl ? 'rtl' : 'ltr'} invertedColors={invertedColors}><L text='Interested in' /></Title>}
      <FlexWrapper>
        <RadioButtonWrapper className={isRtl ? 'ui-rtl-override' : ''} forPopup={forPopup} rtl={isRtl}
          invertedColors={invertedColors}>
          <Radio label={t('Womenswear')} name={name} value='female' checked={value === 'female'} onChange={onChange} />
        </RadioButtonWrapper>
        <RadioButtonWrapper className={isRtl ? 'ui-rtl-override' : ''} forPopup={forPopup} rtl={isRtl}
          invertedColors={invertedColors}>
          <Radio label={t('Menswear')} name={name} value='male' checked={value === 'male'} onChange={onChange} />
        </RadioButtonWrapper>
      </FlexWrapper>
    </RadioButtonsContainer>
  );
};

const Title = styled.p`
  margin-bottom: 8px;
  font-weight: 700;
  font-size: 1.1em;
  color: ${props => props.invertedColors ? '#fff' : '#131313'};
`;

const RadioButtonsContainer = styled.div`
  margin: ${props => props.forPopup ? '16px 0 0 16px' : '16px 0'};

  @media screen and (max-width: 768px) {
    ${props => props.forPopup && 'margin: 0 0 0 16px'};
  }
`;

const RadioButtonWrapper = styled.div`
  margin-left: ${props => props.rtl ? '24px' : '0'};
  margin-right: ${props => !props.rtl ? '24px' : '0'};
  & > div > label {
    color: ${props => props.invertedColors ? '#fff' : '#131313'} !important;
  }

  .ui.checkbox input.hidden+label {
    font-size: ${props => props.forPopup && '16px'};
    margin-top: ${props => props.forPopup && '12px'};
    font-weight: ${props => props.forPopup && '600'};

    @media screen and (max-width: 768px) {
      font-size: ${props => props.forPopup && '10px'};
    }
  }
`;

export default SubscribeGenderInterestRadioButtons;
